/** @type {string} */
const alertComponent = 'Alert';
export default alertComponent;
